module.exports = __webpack_public_path__ + "static/media/icon_ordering.df5ec1f8.svg";